import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";
import { fmtErr } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const user = await login(email, password);
      if (user.role === "admin") navigate("/admin");
      else if (["owner", "manager", "host"].includes(user.role)) navigate("/dashboard");
      else navigate("/my-bookings");
    } catch (err) {
      setError(fmtErr(err));
    }
    setLoading(false);
  };

  return (
    <div data-testid="login-page" className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        className="w-full max-w-md rounded-2xl border border-border/60 bg-card p-8">
        <h1 className="font-display text-3xl tracking-tight">Welcome back</h1>
        <p className="text-sm text-muted-foreground mt-2">Sign in to manage bookings or your restaurant.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <Label className="text-xs tracking-[0.15em] uppercase text-muted-foreground">Email</Label>
            <Input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 bg-background border-border/60" />
          </div>
          <div>
            <Label className="text-xs tracking-[0.15em] uppercase text-muted-foreground">Password</Label>
            <Input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 bg-background border-border/60" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-destructive">{error}</p>}
          <Button data-testid="login-submit-btn" type="submit" disabled={loading} className="w-full rounded-full">
            {loading ? "Signing in..." : "Sign in"}
          </Button>
        </form>
        <p className="text-sm text-muted-foreground mt-6 text-center">
          New here? <Link to="/register" data-testid="goto-register-link" className="text-primary hover:underline">Create an account</Link>
        </p>
      </motion.div>
    </div>
  );
}
